import { create } from "zustand";
import type { BehaviorZoneResult } from "../lib/behaviorZones";

interface BehaviorZoneState {
  fieldId: string | null; // non-null = a behavior-zone session is active
  result: BehaviorZoneResult | null;
  status: "idle" | "computing" | "ready" | "error";
  error: string | null;
  start: (fieldId: string) => void;
  end: () => void;
  computing: () => void;
  ready: (result: BehaviorZoneResult) => void;
  fail: (message: string) => void;
}

export const useBehaviorZoneStore = create<BehaviorZoneState>((set) => ({
  fieldId: null,
  result: null,
  status: "idle",
  error: null,
  start: (fieldId) =>
    set({ fieldId, result: null, status: "idle", error: null }),
  end: () => set({ fieldId: null, result: null, status: "idle", error: null }),
  computing: () => set({ status: "computing", error: null }),
  ready: (result) => set({ result, status: "ready", error: null }),
  fail: (error) => set({ status: "error", error }),
}));
